import React from "react";
import { useEffect, useState } from "react";
import { Modal,Button } from "react-bootstrap";
import {GetComandasByPedidoId} from "../../../../../../../../../../crud/pedidos_api/comandas";
import {markPedidoAsCancelledById} from "../../../../../../../../../../crud/pedidos_api/pedidos";
import {FaExclamationTriangle  } from 'react-icons/fa';
import {toast} from "react-toastify";
import RenderSelections from "../../../../../../../Common/RenderSelections/RenderSelections";
import RenderComandas from "../../../../../../../Common/RenderComandas/RenderComandas";
import './PedidoDetail.scss';


interface RenderPedidoProps {
    pedido: any;
    pedidos?: any[];
    setPedidos?: any;
    show: boolean;
    setShow: (show: boolean) => void;
}


const PedidoDetail: React.FC<RenderPedidoProps> = ({pedido,pedidos,setPedidos, show, setShow}) => {
    const [comandas, setComandas] = useState<any[]>([]);
    const [viewMode, setViewMode] = useState<'pedido' | 'comandas'>('pedido'); 
    const [showAnular, setShowAnular] = useState(false);

    useEffect(() => {
        if (pedido.pedido_id && show) {
            GetComandasByPedidoId(pedido.pedido_id).then((response) => {
                setComandas((response as any).data.reverse());
            }).catch((error) => {
                console.error('Error getting comandas: ', error);
                toast.error('Error obteniendo comandas');
            });
        }
    }, [pedido]);

    const handleToggleView = (mode: 'pedido' | 'comandas') => {
        setViewMode(mode);
      };
    
    const handlePedidoCancelled = () => {
        markPedidoAsCancelledById(pedido.pedido_id).then((response) => {
            toast.success('Pedido marcado como anulado');
            // remove that pedido from pedidos
            const updatedPedidos = pedidos?.filter((p) => p.pedido_id !== pedido.pedido_id);
            setPedidos(updatedPedidos || []);
            setShow(false);
            setShowAnular(false);
        }).catch((error) => {
            console.error('Error marking pedido as cancelled: ', error);
            toast.error('Error marcando pedido como anulado');
        });
    }

    const renderHeaderToggle = () => {
        return (
          <div className="mesa-options-toggle-buttons">
          <Button
            variant='none'
            onClick={() => handleToggleView('pedido')}
            className='toggle-buttons-delivery'
          >
            Pedido
          </Button>
          <Button
            variant='none'
            onClick={() => handleToggleView('comandas')}
            className='toggle-buttons-delivery'
          >
            Comandas
          </Button>
        </div>
        )
      }

    const renderPedidoView = () => {

        return (
            <div className="render-pedido-view-container">
            <RenderSelections
            selections={pedido.selections??[]} showTotal={true}
            />
            <div className="render-pedido-view-actions">
                <Button onClick={() => setShowAnular(true)} variant="none">Anular Pedido <FaExclamationTriangle/></Button>
            </div>
            <Modal show={showAnular}>
                    <Modal.Header>
                        <div className='form-modal-title-container'>
                            <Modal.Title className='form-modal-title'>¿Está seguro que desea anular el pedido?</Modal.Title>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                    <p>Al anular el pedido se eliminarán todas las comandas asociadas al mismo.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="form-button-cancel" variant="none" onClick={() => setShowAnular(false)}>Cancelar</Button>
                    <Button className="form-button-create" variant="none" onClick={handlePedidoCancelled}>Anular Pedido</Button>
                </Modal.Footer>
            </Modal>
            </div>
        );
    }
    
    return (
        <Modal show={show} onHide={() => setShow(false)} centered>
            <Modal.Header>
                <div className='form-modal-title-container'>
                    <Modal.Title className='form-modal-title'>Detalle del Pedido</Modal.Title>
                </div>
            </Modal.Header>
            <Modal.Body>
            {renderHeaderToggle()}
            {viewMode === 'pedido' && renderPedidoView()}
            {viewMode === 'comandas' && <RenderComandas comandas={comandas} setComandas={setComandas} />}
            </Modal.Body>
            <Modal.Footer>
                <div className="form-modal-footer-custom">
                    <Button variant="none" className="form-button-cancel" onClick={() => setShow(false)}>Cerrar</Button>
                </div>
            </Modal.Footer>

        </Modal>
    );
}

export default PedidoDetail;
